<template>
  <div
    class="print-view flex-col items-center justify-center hidden m-0 space-y-6 print:flex a4-dimensions"
  >
    <div class="w-full h-10 p-2 tmsk-blue">
      <img
        class="w-auto h-full"
        src="@/assets/img/staymasked-logo.svg"
        alt="Workflow"
      />
    </div>
    <div class="flex flex-col w-full">
      <div class="flex justify-between px-4 py-2 border-2 tmsk-blue-border">
        <h1 class="font-bold tmsk-blue-text">
          {{ transaction.status === "exchanged" ? "Exchange" : "Receipt" }}:
          {{ transaction.uuid.split("-")[0] }}
        </h1>
        <h1 class="font-bold tmsk-blue-text">
          Total: ${{ transaction.amount.toFixed(2) }}
        </h1>
      </div>
      <div class="border-2 border-t-0 receipt-container tmsk-blue-border">
        <div
          v-for="(item, index) in transaction.items"
          :key="index"
          class="p-3 border-b-2 last:border-0 content-container tmsk-blue-border"
        >
          <!-- Items -->
          <div class="tmsk-blue-text">
            <div class="flex items-center mb-4 space-x-4">
              <!-- Details -->
              <div class="flex-1 text-xs">
                <h2 class="w-full text-base font-bold tmsk-blue-text" data-e2e-attr="sku-mask-name">
                  <span
                    data-e2e-attr="sku-mask-name"
                    :style="`color: ${getAlternativeNameColour(item.sku)}`"
                    >{{ getAlternativeName(item.sku) }} </span
                  > <span class="font-extrabold">MaskPure™</span>
                </h2>
                <p>
                  {{ item.name }}
                </p>
                <p class="mt-2" data-e2e-attr="sku-price">
                  <span class="font-bold">Price: </span>{{
                    transaction.status === "exchanged"
                      ? "Not For Sale"
                      : `$${item.price.toFixed(2)}/mask (RRP: $${item.rrp.toFixed(2)}/mask)`}}
                </p>
                <p>
                  <span class="font-bold">Collected:</span>
                  {{ item.qtyTotal - item.qtyUncollected }} /
                  {{ item.qtyTotal }}
                </p>
                <p>
                  <span class="font-bold">Amount:</span>
                  {{
                    transaction.status === "exchanged"
                      ? "Not For Sale"
                      : `$${(item.qtyTotal * item.price).toFixed(2)}`
                  }}
                </p>
                <p
                  v-if="
                    (transaction.status === 'success' && !isCollected) ||
                    transaction.status === 'exchanged'
                  "
                  class="mt-6 text-red-700"
                >
                  No partial refund is allowed on this order.
                </p>
                <p class="mt-2 text-red-700"
                   data-e2e-attr="sku-mask-qrcode-collection">
                  Scan QR code to collect your mask from <span
                    data-e2e-attr="sku-available-location-text"
                    class="font-bold underline cursor-pointer"
                    @click="routeToLocateVM(item.sku)"
                  >over 800 locations island-wide.
                  </span
                  >
                </p>
              </div>
              <!-- QR Code -->
              <div class="relative p-0" style="width: 125px; height: 125px">
                <template
                  v-if="
                    (item.qtyUncollected === 0 &&
                      ['success', 'exchanged'].includes(transaction.status)) ||
                    ['refunded'].includes(transaction.status)
                  "
                >
                  <p
                    v-if="
                      item.qtyUncollected === 0 &&
                      ['success', 'exchanged'].includes(transaction.status)
                    "
                    class="z-30 flex items-center justify-center w-full h-full text-xl font-extrabold text-red-600 abs-center"
                  >
                    COLLECTED
                  </p>
                  <p
                    v-else-if="['refunded'].includes(transaction.status)"
                    class="z-30 flex items-center justify-center w-full h-full text-xl font-extrabold text-red-600 abs-center"
                  >
                    REFUNDED
                  </p>
                </template>
                <div
                  :style="
                    ((item.qtyUncollected === 0 &&
                      ['success', 'exchanged'].includes(transaction.status)) ||
                      ['refunded'].includes(transaction.status)) &&
                    'opacity: 0.15;'"
                >
                  <qr-code
                    level="Q"
                    :value="
                      (item.qtyUncollected === 0 &&
                        ['success', 'exchanged'].includes(
                          transaction.status
                        )) ||
                      transaction.status === 'refunded'
                        ? ''
                        : item.qr
                    "
                    renderAs="canvas"
                    :size="125"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import QrCode from 'qrcode.vue'
export default {
  name: 'PrintableReceipt',
  components: {
    QrCode
  },
  mixins: [],
  props: {
    transaction: {
      type: Object,
      required: true
    }
  },
  data () {
    return {}
  },
  computed: {},
  watch: {},

  // Lifecycle Hooks
  beforeCreate () {},
  created () {},
  beforeMount () {},
  mounted () {},
  beforeUpdate () {},
  updated () {},
  beforeDestroy () {},
  destroyed () {},
  methods: {
    isCollected (items) {
      // qtyUncollected > 0 = pending collection
      const uncollectedItem = items.find(item => item.qtyUncollected > 0)
      if (uncollectedItem === undefined) return true
      else return false
    },

    getAlternativeName (sku) {
      switch (sku) {
        case 'SM6_MASK_M':
          return 'Size M'
        case 'SM6_MASK_L':
          return 'Size L'
      }
    },

    getAlternativeNameColour (sku) {
      switch (sku) {
        case 'SM6_MASK_M':
          return '#63656a'
        case 'SM6_MASK_L':
          return '#221f20'
      }
    }
  }
}
</script>

<style scoped>
.a4-dimensions {
  max-width: 2480px;
  max-height: 3508px;
}

.abs-center {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}

.tmsk-blue {
  background-color: #9fdafc;
}

@media only print {
  html, body {
    border: 1px solid white;
    height: 99%;
    page-break-after: avoid;
    page-break-before: avoid;
  }

  .print-view {
    page-break-after: auto;
  }

  .receipt-container {
    width: 100%;
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
  }

  /* .content-container {
    width: 50%;
  } */
  .content-container {
    width: 100%;
  }

  /* .content-container:last-child:not(:nth-child(even)) {
    width: 50%;
    margin: 0 auto;
  } */
}
</style>
